import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";

const AboutTheContest = ({ contestDetail }) => {
  const contestInfo = [
    { key: "Prize Pool*", value: contestDetail?.prize_pool },
    { key: "Entry Fee", value: contestDetail?.entry_fee },
    { key: "Coins you will get", value: contestDetail?.virtual_credits },
    { key: "Winner", value: "Top " + contestDetail?.winner_percentage + "%" },
  ];
  return (
    <View style={styles.aboutContestContainer}>
      <View style={styles.topContainer}>
        <Text
          style={{ ...globalFontStyle.appFontSubTextWeight, marginBottom: 5 }}
        >
          {contestDetail?.title}
        </Text>
        <Text
          style={{ ...globalFontStyle.appFontSmallText, color: Color.grey2 }}
        >
          {contestDetail?.description}
        </Text>
      </View>
      <View style={{ paddingHorizontal: 15, paddingVertical: 8 }}>
        {contestInfo.map((item) => {
          return (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingVertical: 8,
              }}
            >
              <Text style={styles.text1}>{item?.key}</Text>
              <Text style={styles.text1}>{item?.value}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default AboutTheContest;

const styles = StyleSheet.create({
  aboutContestContainer: {
    // elevation: 5,
    borderWidth: 0.2,
    borderRadius: 8,
    borderColor: "rgba(0, 0, 0, 0.25)",
  },
  text1: {
    ...globalFontStyle.appFontSmallText,
    color: Color.grey2,
  },
  topContainer: {
    backgroundColor: Colors.grey3,
    paddingLeft: 10,
    paddingRight: 20,
    paddingVertical: 15,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
});
